<template>
<div>
  <v-row class="mb-4">
    <v-col md="1">
      <slot name="navigationPrev"></slot>
    </v-col>

    <v-col md="1" class="text-right">
      <slot name="navigationNext"></slot>
    </v-col>
  </v-row>

  <div v-for="(field, k) in filteredFields" :key="k">
    <inquiry-field :field="field" :marketing-type="marketingType" filled @update="update"></inquiry-field>
  </div>
</div>
</template>

<script>
import InquiryField from "./InquiryField";

export default {
  name: "InquiryFields",

  components: {
    InquiryField
  },

  props: [
    "fields",
    "marketingType",
    "category"
  ],

  computed: {
    filteredFields() {
      return this.fields.filter(f => {
        return this.category.fieldList.find(f1 => f1.var == f.id);
      });
    }
  },

  methods: {
    update(event) {
      this.$emit("fieldChanged", event);
    }
  }
};
</script>
